import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  TextField
} from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { emptyValidator } from '../../libs/valid-rule';
import { getForm, getLanguage, telOptions } from '../../libs/formData';
import { getLanguageList } from '../../libs/date';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import CommonIconButton from '../../components/CommonIconButton';
import Context from '../../provider';
import InputComponent from '../../components/InputComponent';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import NativeSelect from '@mui/material/NativeSelect';
import React, { useContext, useEffect, useState } from 'react';
import ToggleGroupComponent from '../../components/ToggleGroupComponent';
import UploadComponent from '../../components/UploadComponent';
import * as dayjs from 'dayjs';
import './index.scss';

export default function TierFormGroupComponent(props) {
  const {
    membershipRecord,
    tierType,
    countryCode,
    fileInfo = null,
    onNext
  } = props;

  const { t } = useTranslation();

  const { isMobile, dispatch } = useContext(Context);

  const [membershipFormRecord, setMembershipFormRecord] = useState(null);
  const [formFile, setFormFile] = useState(null);
  const [typeForm, setTypeForm] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [fromAboutOptions, setFromAboutOptions] = useState([]);
  // 联系方式
  const [mobileCountryCode, setMobileCountryCode] = useState();
  const [contactNum, setContactNum] = useState('');
  // 邮寄地址
  const [addressOne, setAddressOne] = useState('');
  const [addressTwo, setAddressTwo] = useState('');
  const [mailingCity, setMailingCity] = useState('');
  const [mailingProvince, setMailingProvince] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [mailingCountry, setMailingCountry] = useState('');

  const [activeNext, setActiveNext] = React.useState(false);

  const GroupHeader = styled('div')(({ theme }) => ({
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main
  }));

  const GroupItems = styled('ul')({
    padding: 0
  });

  useEffect(() => {

    const titleOptions = [
      { label: t('registration.prof'), data: 'prof' },
      { label: t('registration.dr'), data: 'dr' },
      { label: t('registration.mr'), data: 'mr' },
      { label: t('registration.ms'), data: 'ms' },
      { label: t('registration.mrs'), data: 'mrs' }
    ];

    setTitleOptions(titleOptions);

    const fromAboutOptions = [
      { label: t('registration.search-desc'), group: t('registration.search'), data: 'search' },
      { label: t('registration.website'), group: t('registration.website'), data: 'website' },
      { label: t('registration.email'), group: t('registration.email'), data: 'email' },
      { label: t('registration.facebook'), group: t('registration.social-media'), data: 'facebook' },
      { label: t('registration.instagram'), group: t('registration.social-media'), data: 'instagram' },
      { label: t('registration.linkedIn'), group: t('registration.social-media'), data: 'linkedIn' },
      { label: t('registration.x'), group: t('registration.social-media'), data: 'x' },
      { label: t('registration.weibo'), group: t('registration.social-media'), data: 'weibo' },
      { label: t('registration.wechat'), group: t('registration.social-media'), data: 'wechat' },
      { label: t('registration.red-book'), group: t('registration.social-media'), data: 'red-book' },
      { label: t('registration.hkdc-event'), group: t('registration.hkdc-event'), data: 'hkdc-event' },
      { label: t('registration.friend'), group: t('registration.friend'), data: 'friend' },
      { label: t('registration.other'), group: t('registration.other'), data: 'other' }
    ];

    setFromAboutOptions(fromAboutOptions);
  }, []);

  useEffect(() => {
    if (membershipFormRecord) {
      if (typeForm.length > 0) {
        const isRequest = typeForm.every((item) => {
          if (item.group === 1) {
            if (item.isRequest) {
              if (item.id === 'aware_hkdc_channel_event') {
                if (membershipFormRecord.aware_hkdc_channel === "hkdc-event") {
                  return !!membershipFormRecord[item.id];
                }
                return true;
              } else if (item.id === 'aware_hkdc_channel_other') {
                if (membershipFormRecord.aware_hkdc_channel === "other") {
                  return !!membershipFormRecord[item.id];
                }
                return true;
              } else if (item.type === "check") {
                return membershipFormRecord[item.id] === "1";
              } else if (item.id === 'student_card_images' || item.id === 'br_images') {
                if (membershipFormRecord[item.id]) {
                  if (Array.isArray(membershipFormRecord[item.id])) {
                    return !!membershipFormRecord[item.id][0];
                  }
                }
              }

              return !!membershipFormRecord[item.id];
            } else {
              return true;
            }
          } else {
            return true;
          }
        });

        setActiveNext(isRequest);
      }
    } else {
      setActiveNext(false);
    }
  }, [membershipFormRecord]);

  useEffect(() => {
    setMembershipFormRecord({ ...membershipFormRecord, contact_number: mobileCountryCode + ' ' + contactNum });
  }, [mobileCountryCode, contactNum]);

  useEffect(() => {
    setMembershipFormRecord({
      ...membershipFormRecord,
      mailing_address: `${addressOne}, ${addressTwo}, ${mailingCity}, ${mailingProvince},${postalCode}, ${mailingCountry}`
    });
  }, [addressOne, addressTwo, mailingCity, mailingProvince, postalCode, mailingCountry]);

  useEffect(() => {
    if (tierType && tierType !== '') {
      setTypeForm(getForm(tierType));
    }
  }, [tierType]);

  useEffect(() => {
    if (fileInfo) {
      setFormFile(fileInfo);
    }

  }, [fileInfo]);

  useEffect(() => {
    if (membershipRecord) {
      setMembershipFormRecord(membershipRecord);
    }
  }, [membershipRecord]);

  useEffect(() => {
    if (countryCode && countryCode !== '') {
      setMobileCountryCode(countryCode);
    } else {
      setMobileCountryCode('+852');
    }
  }, [countryCode]);

  const languageChange = (value) => {
    let language = 'en';
    if (value !== 'en') {
      language = value === 'tc' ? 'zh-HK' : 'zh-CN';
    }
    setMembershipFormRecord({ ...membershipFormRecord, preference_language: language });
  };

  /**
   * 文件上传
   */
  const handleFileUpload = (file, type) => {
    if (file) {
      setFormFile(file);
    } else {
      setFormFile(null);
    }

    setMembershipFormRecord({ ...membershipFormRecord, [type]: file });
  };

  return (
    <>
      <form className={`${isMobile ? 'mobile' : 'web'}-form-group`}>
        {typeForm && typeForm.length > 0 &&
          typeForm.map((formItem, index) => {
            if (formItem.group !== 1) return null;
            switch (formItem.type) {
              case 'select':
                return (
                  <Autocomplete
                    key={index}
                    label={t(formItem.label)}
                    value={ titleOptions.find((item) => item.data === membershipFormRecord[formItem.id]) }
                    id="combo-box-demo"
                    sx={{
                      width: isMobile ? undefined : '27.5rem'
                    }}
                    options={titleOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => {
                      e.stopPropagation();
                      if (value && value.data) {
                        setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: value.data });
                      } else {
                        setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: "" });
                      }
                    }}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Box
                          key={key}
                          component="li"
                          sx={
                            isMobile ? undefined : {
                            fontSize: '1.4375rem',
                            fontWeight: '400',
                            fontFamily: 'var(--text-font-family)',
                            lineHeight: '1.6225rem'
                          }}
                          {...optionProps}
                        >
                          {option.label}
                        </Box>
                      );
                    }}
                    renderInput={(params) =>
                      <TextField
                        sx={
                          isMobile ? {
                            width: undefined
                          } : {
                            '.MuiInputLabel-root': {
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            },
                            '.MuiInputBase-input': {
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            }
                          }
                        }
                        error={!membershipFormRecord[formItem.id]}
                        {...params}
                        variant="standard"
                        label={t(formItem.label)}
                      />}
                  />);
              case 'from-select':
                return (
                  <Autocomplete
                    key={index}
                    fullWidth={true}
                    value={ fromAboutOptions.find((item) => item.data === membershipFormRecord[formItem.id]) }
                    label={t(formItem.label)}
                    id="combo-box-demo"
                    className='from-select'
                    sx={{
                      width: isMobile ? undefined : '27.5rem'
                    }}
                    options={fromAboutOptions}
                    getOptionLabel={(option) => option.label}
                    groupBy={(option) => option.group}
                    renderGroup={(params) => {
                      return (
                        <li key={params.key}>
                          {
                            params.children.length > 1 &&
                            <GroupHeader>{params.group}</GroupHeader>
                          }
                          <GroupItems sx={{
                            padding: params.children.length <= 1 ? '0 0.5rem' : '0 1.5rem'
                          }}>{params.children}</GroupItems>
                        </li>
                      );
                    }}
                    onChange={(e, value) => {
                      e.stopPropagation();
                      if (value && value.data) {
                        setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: value.data });
                      } else {
                        setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: "" });
                      }
                    }}
                    renderOption={(props, option) => {
                      const { key, ...optionProps } = props;
                      return (
                        <Box
                          key={key}
                          component="li"
                          sx={
                            isMobile ? {
                              fontSize: '1rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.125rem',
                              top: '-1rem'
                            } : {
                            fontSize: '1.4375rem',
                            fontWeight: '400',
                            fontFamily: 'var(--text-font-family)',
                            lineHeight: '1.6225rem',
                            top: '0'
                          }}
                          {...optionProps}
                        >
                          {option.label}
                        </Box>
                      );
                    }}
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        error={!membershipFormRecord[formItem.id]}
                        variant="standard"
                        label={t(formItem.label)}
                        sx={
                          isMobile ? {
                            '.MuiInputLabel-root': {
                              fontSize: '1rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.125rem',
                              top: '-1rem'
                            }
                          } : {
                            '.MuiInputLabel-root': {
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem',
                              top: '-1rem'
                            },
                            '.MuiInputBase-input': {
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            }
                          }
                        }
                      />}
                  />
                );
              case 'input':
                return (
                  <InputComponent
                    key={index}
                    onValueChange={(value) => {
                      setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: value });
                    }}
                    defaultValue={membershipFormRecord[formItem.id]}
                    inputTextStyle={
                      isMobile ? undefined : {
                      fontSize: '1.4375rem',
                      fontWeight: '400',
                      fontFamily: 'var(--text-font-family)',
                      lineHeight: '1.6225rem'
                    }}
                    helperTextStyle={
                      isMobile ? undefined : {
                      fontSize: '1rem',
                      lineHeight: '1.5rem'
                    }}
                    iconStyle={
                      isMobile ? undefined : {
                      fontSize: '1.25rem'
                    }}
                    validator={emptyValidator}
                    customerError={t(formItem.label)}
                    label={t(formItem.label)}
                    fullWidth={isMobile ? true : false}
                    componentContStyle={{
                      width: isMobile ? undefined : '27.5rem'
                    }}
                  />);
              case 'date':
                let defaultValue = null;
                if (membershipFormRecord[formItem.id] && membershipFormRecord[formItem.id] !== '') {
                  defaultValue = dayjs(membershipFormRecord[formItem.id]);

                  if (formItem.id === 'dob') {
                    defaultValue = dayjs(membershipFormRecord[formItem.id]).set('year', dayjs().get('year'));
                  }
                }

                return (
                  <DesktopDatePicker
                    minDate={formItem.min}
                    maxDate={formItem.max}
                    defaultValue={defaultValue}
                    views={formItem.views}
                    label={t(formItem.label)}
                    key={index}
                    sx={{
                      width: isMobile ? undefined : '27.5rem',
                      '.MuiInputLabel-root': isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      },
                      '.MuiInputBase-input': isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }
                    }}
                    format={formItem.format}
                    onChange={(value) => {
                      setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: dayjs(value).format(formItem.format) });
                    }}
                    slotProps={{
                      textField: {
                        error: membershipFormRecord[formItem.id] ? false :true,
                        variant: 'standard'
                      },
                      layout: {
                        sx: {
                            '.MuiPickersCalendarHeader-root': formItem.id === 'dob' ? {
                              visibility: 'hidden'
                            }: undefined,
                            '.MuiDayCalendar-weekDayLabel': isMobile ? undefined : {
                              color: 'gray',
                              borderRadius: '2px',
                              borderWidth: '0px',
                              border: '0px solid',
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            },
                            '.MuiPickersDay-root': isMobile ? undefined : {
                              color: '#000',
                              borderRadius: '2px',
                              borderWidth: '0px',
                              border: '0px solid',
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            },
                            '.MuiPickersDay-today': isMobile ? undefined : {
                              color: '#fff',
                              backgroundColor: '#004899'
                            },
                            '.MuiPickersMonth-monthButton': isMobile ? undefined : {
                              color: '#000',
                              borderRadius: '2px',
                              borderWidth: '0px',
                              border: '0px solid',
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            },
                            '.MuiPickersYear-yearButton': isMobile ? undefined : {
                              color: '#000',
                              borderRadius: '2px',
                              borderWidth: '0px',
                              border: '0px solid',
                              fontSize: '1.4375rem',
                              fontWeight: '400',
                              fontFamily: 'var(--text-font-family)',
                              lineHeight: '1.6225rem'
                            }
                        }
                      }
                    }}
                  />
                );
              case 'tel':
                let country_code = countryCode;
                let mobile_number = '';
                if (membershipFormRecord[formItem.id] && membershipFormRecord[formItem.id] !== '') {
                  const mobiles = membershipFormRecord[formItem.id].split(' ');
                  if (mobiles.length === 2) {
                    country_code = mobiles[0] !== '' ? mobiles[0] : countryCode;
                    mobile_number = mobiles[1];
                  }
                  console.log(country_code, mobile_number);
                }

                return (
                  <div key={index} style={{ width: isMobile ? undefined : '27.5rem' }} className="tel-form-group">
                    <NativeSelect
                      name="country_code"
                      defaultValue={ country_code }
                      disableUnderline={true}
                      style={{
                        width: isMobile ? undefined : '7rem',
                        fontSize: isMobile ? undefined : '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: isMobile ? undefined : '1.6225rem'
                      }}
                      onChange={(e) => {
                        e.stopPropagation();
                        setMobileCountryCode(e.target.value);
                      }}
                    >
                      {telOptions.map((code) => {
                        return (<option key={code} value={code}>{code}</option>);
                      })}
                    </NativeSelect>
                    <InputComponent
                      onValueChange={(value) => {
                        setContactNum(value);
                      }}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      defaultValue={mobile_number}
                      inputType="number"
                      label={t(formItem.label)}
                      fullWidth={true}
                      error={false}
                    />
                  </div>
                );
              case 'upload':
                return (
                  <UploadComponent
                    componentClass={`${isMobile ? 'mobile' : 'web'}-upload-cont`}
                    key={index}
                    onChangeFile={(fileData) => {
                      handleFileUpload(fileData, formItem.id);
                    }}
                    onError={(err) => {
                      dispatch({
                        type: 'SET_ERROR_DIALOG',
                        payload: { open: true, message: t(err) }
                      });
                    }}
                    fileNameText={ formFile ? formFile.name : null}
                    uploadTitleText={t(formItem.label)}
                    fileTitleText={t(formItem.fileTitle)}
                    acceptText="image/png, image/jpg, image/jpeg, .pdf"
                    descText={t(formItem.desc)}
                    uploadText={t('common.upload')}
                  />
                );
              case 'language':
                return (
                  <div
                    key={index}
                    className={isMobile ? 'language-form-item-cont' : "form-cont"}
                    style={{ width: isMobile ? undefined : '27.5rem' }}
                  >
                    <div className="title-content-cont">
                      <div className="title-text">
                        {t(formItem.label)}
                      </div>
                      <div className="content-text">
                        {t(formItem.desc)}
                      </div>
                    </div>
                    <ToggleGroupComponent
                      isChange={false}
                      defaultValue={getLanguage(membershipFormRecord[formItem.id])}
                      groupList={getLanguageList()}
                      onChange={languageChange}
                    />
                  </div>
                );
              case 'mailing-input':
                return (
                  <div key={index}
                    className="mailing-cont"
                    style={{ width: isMobile ? undefined : '27.5rem' }}
                  >
                    <div className="title-text">
                      {t(formItem.label)}
                    </div>
                    <InputComponent
                      multiline={true}
                      onValueChange={(value) => {
                        setAddressOne(value);
                      }}
                      label={t('registration.address-one')}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      fullWidth={true}
                    />
                    <InputComponent
                      multiline={true}
                      onValueChange={(value) => {
                        setAddressTwo(value);
                      }}
                      label={t('registration.address-two')}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      fullWidth={true}
                    />
                    <InputComponent
                      multiline={true}
                      onValueChange={(value) => {
                        setMailingCity(value);
                      }}
                      label={t('registration.city')}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      fullWidth={true}
                    />
                    <InputComponent
                      multiline={true}
                      onValueChange={(value) => {
                        setMailingProvince(value);
                      }}
                      label={t('registration.province')}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      fullWidth={true}
                    />
                    <InputComponent
                      multiline={true}
                      onValueChange={(value) => {
                        setPostalCode(value);
                      }}
                      label={t('registration.postal-code')}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      fullWidth={true}
                    />
                    <InputComponent
                      multiline={true}
                      onValueChange={(value) => {
                        setMailingCountry(value);
                      }}
                      label={t('registration.country')}
                      inputTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }}
                      helperTextStyle={
                        isMobile ? undefined : {
                        fontSize: '1rem',
                        lineHeight: '1.5rem'
                      }}
                      iconStyle={
                        isMobile ? undefined : {
                        fontSize: '1.25rem'
                      }}
                      fullWidth={true}
                    />
                  </div>
                );
              case "option-input":
                return (
                  <TextField
                    key={index}
                    style={{ display: membershipFormRecord.aware_hkdc_channel === formItem.showType ? 'block' : 'none' }}
                    id="outlined-basic"
                    fullWidth={isMobile ? true : false}
                    sx={{
                      width: isMobile ? undefined : '27.5rem',
                      '.MuiInputLabel-root': isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      },
                      '.MuiInputBase-input': isMobile ? undefined : {
                        fontSize: '1.4375rem',
                        fontWeight: '400',
                        fontFamily: 'var(--text-font-family)',
                        lineHeight: '1.6225rem'
                      }
                    }}
                    defaultValue={membershipFormRecord[formItem.id]}
                    label={t(formItem.label)}
                    variant="outlined"
                    onChange={(e) => {
                      e.stopPropagation();
                      setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: e.target.value });
                    }}
                  />
                );
              case "number-input":
                return (
                  <div
                    key={index}
                    className={isMobile ? 'email-form-item-cont' : "form-cont"}
                    style={{ width: isMobile ? undefined : '27.5rem' }}
                  >
                    <div className="title-content-cont">
                      <div className="title-text">
                        {t(formItem.label)}
                      </div>
                      <div className="content-text">
                        {t(formItem.desc)}
                      </div>
                    </div>
                    <TextField
                      id="outlined-basic"
                      defaultValue={membershipFormRecord[formItem.id]}
                      sx={{
                        '.MuiInputLabel-root': isMobile ? undefined : {
                          fontSize: '1.4375rem',
                          fontWeight: '400',
                          fontFamily: 'var(--text-font-family)',
                          lineHeight: '1.6225rem'
                        },
                        '.MuiInputBase-input': isMobile ? undefined : {
                          fontSize: '1.4375rem',
                          fontWeight: '400',
                          fontFamily: 'var(--text-font-family)',
                          lineHeight: '1.6225rem'
                        }
                      }}
                      slotProps={{
                        inputProps: {
                          type: 'number'
                        }
                      }}
                      label="Enter code"
                      variant="outlined"
                      onChange={(e) => {
                        e.stopPropagation();
                        setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: e.target.value });
                      }}
                    />
                  </div>
                );
              case "check":
                return (
                  <FormControlLabel
                    key={index}
                    className="check-box"
                    fullWidth={true}
                    sx={{
                      // color: membershipFormRecord[formItem.id] !== '1' ? '#d32f2f' : undefined
                    }}
                    control={
                    <Checkbox
                      defaultChecked={membershipFormRecord[formItem.id] === '1'}
                      onChange={(e) => {
                      e.stopPropagation();
                      setMembershipFormRecord({ ...membershipFormRecord, [formItem.id]: e.target.checked ? '1' : '0' });
                    }} />}
                    label={t(formItem.label)}
                  />
                );
              default:
                return null;
            }
          })
        }
      </form>
      <div className="full-width">
        <CommonIconButton
          text={t('common.next-btn')}
          endIcon= {<KeyboardArrowRightIcon />}
          disabled={!activeNext}
          backgroundColor= {!activeNext ? '#C6C6C5' : '#004899'}
          btnColor = "#ffffff"
          btnWidth= { isMobile ? '8.75rem' : "15.26rem"}
          padding = { isMobile ? "0.375rem 1.75rem" : "0.625rem 3rem"}
          btnFontSize = { isMobile ? "1.125rem" : "1.9375rem"}
          btnFontWeight = { isMobile ? "700" : "500"}
          onClick={(e) => {
            e.stopPropagation();
            onNext(membershipFormRecord, formFile);
          }}
        />
      </div>
    </>
  );
}